// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"0fae494c97e5b46f6f76","245":"1934308f66910aa3b46b","453":"d4fc2b0959492c4fa8c8"}[chunkId] + ".js";
};